import { patch } from 'bootstrap/load-snabbdom';
import { VNode } from 'snabbdom/vnode';
import { IncidentType, IHeadingInfo } from './model';


interface ISortOptions {
	sortAction(evt : JQuery.ClickEvent) : void
}

function Header({
	displayedTypes,
	headings,
	sortAction,
} : {
	displayedTypes : IncidentType[];
	headings : IHeadingInfo[];
	sortAction(evt : JQuery.ClickEvent) : void;
}) {

	const isIncidentList = displayedTypes.includes('INCIDENT');
	const hiddenFields = ['scn', 'customerName'];

	return <thead>
		<tr>
			{headings
				.filter(item => isIncidentList || !hiddenFields.includes(item.sortName))
				.map(item => {
					return <th
						attrs-data-sort-name={item.sortName}
						className="font--semi-bold"
						on-click={item.sort ? [sortAction] : undefined}
					>
						{item.title} {item.sort && <i className="tablesorter-icon"></i>}
					</th>;
		})}
		</tr>
	</thead>;
}

export class TableHeader {
	private target : HTMLElement | VNode;
	private headings : IHeadingInfo[];
	private sortOptions : ISortOptions;
	private displayedTypes : IncidentType[];

	constructor(
		target : HTMLElement,
		headings : IHeadingInfo[],
		sortOptions : ISortOptions,
		displayedTypes : IncidentType[],

	) {
		this.target = target;
		this.headings = headings;
		this.sortOptions = sortOptions;
		this.displayedTypes = displayedTypes;
	}

	public render() {
		this.target = patch(
				this.target,
				<Header
					headings={this.headings}
					// tslint:disable-next-line:no-unbound-method
					sortAction={this.sortOptions.sortAction}
					displayedTypes={this.displayedTypes}
				/>,
			);
	}

	public clear() {
		this.target = patch(
			this.target,
			<thead></thead>,
		);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/pex/TableHeader.tsx